<template>
<div class="with-sidebar-content  gdlr-item-start-content columns">

    <div v-if="withoutCookieLatestSpecialDay && withoutCookieLatestSpecialDay.specialDayDetails && mlcActiveLocations && mlcActiveLocations.length" class="blog-item-holder special-days-details-description">

        <template v-for="(activeLocation, index) in mlcActiveLocations" :key="index">
            <div class="mlc-location-dependent-block-invisible" :class="activeLocation.identifier">
                <div v-if="activeLocation.specialDayDetails && activeLocation.specialDayDetails.details" class="gdlr-item gdlr-blog-medium rounded-l sday-detail-styling">
                    <h3 v-if="postTitle">{{postTitle}}</h3>

                    <p>{{activeLocation.specialDayDetails.details}}</p>
                </div>
            </div>
        </template>
        <div v-if="withoutCookieLatestSpecialDay && withoutCookieLatestSpecialDay.specialDayDetails && withoutCookieLatestSpecialDay.specialDayDetails.details" class="mlc-location-independent-block-invisible gdlr-item gdlr-blog-medium rounded-l sday-detail-styling">
            <h3 v-if="postTitle">{{postTitle}}</h3>

            <p>{{withoutCookieLatestSpecialDay.specialDayDetails.details}}</p>
        </div>

    </div>
</div>
</template>

<script>
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import {
    watch
} from 'vue'

import moment from 'moment'
export default {
    name: "SpecialDayDetailTop",

    data() {
        return {
            conferenceBrandId: this.settingsPerm.conferenceBrandId,
            mlcActiveLocations: this.settingsPerm.mlcactivelocation,
            theMaybeSetPLLCookieValue: window.jQuery.cookie("pll_language"),
            postSlug: this.settingsPerm.postSlug,
            postTitle: this.settingsPerm.postTitle,
            counter: 0,
            withoutCookieLatestSpecialDay: false,
        };
    },

    created() {
        if (this.conferenceBrandId && this.mlcActiveLocations && this.postSlug && this.postTitle) {
            if (this.mlcActiveLocations && this.mlcActiveLocations.length && this.mlcActiveLocations.length > 0) {
                this.mlcActiveLocations.forEach((location) => {
                    if (location && location.select_series && location.select_series.length && location.select_series.length > 0 && location.select_series[0]) {
                        this.getAndDisplayCorrectInfo(location.select_series[0]);
                    }
                });

            }
        }
    },

    props: {
        settingsPerm: Object
    },
    methods: {
        getAndDisplayCorrectInfo(seriesID) {
            const cache = new InMemoryCache();
            const apolloClient = new ApolloClient({
                cache,
                uri: window.walkuere_app_data.concord_url,
            })
            provideApolloClient(apolloClient)
            let variablesForInstance = {
                conferenceBrandId: this.conferenceBrandId,
                id: seriesID
            };

            const {
                result
            } = useQuery(CONCORD_QUERIES.SPECIAL_DAYS_QUERY, variablesForInstance);
            watch(result, value => {
                if (result && value && value.vueSpecialDays && value.vueSpecialDays.Meta && value.vueSpecialDays.Meta.count && value.vueSpecialDays.Meta.count > 0 && value.vueSpecialDays.SpecialDays && value.vueSpecialDays.SpecialDays.length) {
                    let doWeHaveAMatchingSpecialDay = value.vueSpecialDays.SpecialDays.find(aSpecialDay => aSpecialDay && aSpecialDay.uniqueId && aSpecialDay.name == this.postTitle);
                    if (doWeHaveAMatchingSpecialDay && doWeHaveAMatchingSpecialDay.details && doWeHaveAMatchingSpecialDay.details.length && doWeHaveAMatchingSpecialDay.name && this.mlcActiveLocations) {
                        this.mlcActiveLocations.forEach(singleLocation => {
                            if (singleLocation && singleLocation.select_series && singleLocation.select_series.length && singleLocation.select_series.length > 0 && singleLocation.select_series[0] == seriesID) {
                                singleLocation.specialDayDetails = doWeHaveAMatchingSpecialDay;
                                singleLocation.specialDayDate = doWeHaveAMatchingSpecialDay.localizedStartDate;
                            }
                            this.counter++;
                            if (this.counter == this.mlcActiveLocations.length) {
                                this.filterLatestSpecialDay(this.mlcActiveLocations);
                            }
                        });
                    }

                }
            });
        },

        filterLatestSpecialDay(locationData) {
            if (locationData) {
                let locationSortedByDate = locationData.sort((a, b) => {
                    if (a.specialDayDate && b.specialDayDate) {
                        return moment(b.specialDayDate, 'DD-MM-YYYY') - moment(a.specialDayDate, 'DD-MM-YYYY');
                    }
                });
                this.withoutCookieLatestSpecialDay = locationSortedByDate.find(aLocation => aLocation && aLocation.specialDayDetails && aLocation.specialDayDetails.details);
            }
            this.setVisibilities();
        },

        setVisibilities() {
            setTimeout(() => {
                let cookie = window.jQuery.cookie("event_location");
                if (cookie && (typeof cookie !== "undefined") && (cookie != "") && (cookie != "all")) {
                    window.jQuery('.mlc-location-dependent-block-invisible.' + cookie).addClass('mlc-location-dependent-block-visible');
                    window.jQuery('.mlc-location-dependent-block-invisible.' + cookie).removeClass('mlc-location-dependent-block-invisible');
                } else {
                    // we do NOT have a location so we do somtehing with location dependend things
                    window.jQuery('.mlc-location-independent-block-invisible').addClass('mlc-location-independent-block-visible');
                    window.jQuery('.mlc-location-independent-block-invisible').removeClass('mlc-location-independent-block-invisible');
                }
                if (this.theMaybeSetPLLCookieValue && (typeof this.theMaybeSetPLLCookieValue !== "undefined") && (this.theMaybeSetPLLCookieValue != "") && (this.theMaybeSetPLLCookieValue == 'de')) {
                    window.jQuery('.language-dependent-block-invisible-de').addClass('language-dependent-block-visible');
                    window.jQuery('.language-dependent-block-invisible-de').removeClass('language-dependent-block-invisible-de');
                } else {
                    window.jQuery('.language-dependent-block-invisible').addClass('language-dependent-block-visible');
                    window.jQuery('.language-dependent-block-invisible').removeClass('language-dependent-block-invisible');
                }
            }, 500);
        }
    },

};
</script>

<style scoped>
.sday-detail-styling {
    font-size: 24px;
    padding: 25px;
}

.rounded-l {
    border-radius: 20px !important;
}
</style>
